import React, { memo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Modal, ModalBody, ModalFooter, ModalHeader } from '@pwc/appkit-react/lib/Modal';
import { Input } from '@pwc/appkit-react/lib/Input';

import Button from '../../../../shared/button.component';
import FileUploadButton from '../../../../shared/fileUpload/fileUploadButton.component';

import { MdFileUpload as FileUploadIcon } from 'react-icons/md';
import { FaImage as ImageIcon } from 'react-icons/fa';

const PictureUploadButton = ({ size, editor }) => {
  const [modalOpened, setModalOpened] = useState(false);
  const [url, setUrl] = useState('');
  const [uploadError, setUploadError] = useState(null);

  const handleOpenClick = useCallback(() => {
    setModalOpened(true);
    setUrl('');
    setUploadError(null);
  }, []);
  const handleCloseClick = useCallback(() => setModalOpened(false), []);

  const handleFile = useCallback(event => {
    const file = event.target.files[0];

    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;

      const editorLastPosition = editor.getLastPosition();
      if (editorLastPosition) {
        editor.select(editorLastPosition);
      }
      editor.insertImage(dataUrl);

      setModalOpened(false);
      setUploadError(null);
    };
    reader.onabort = () => setUploadError('Picture upload aborted. Try again.');
    reader.onerror = () => setUploadError('Picture upload error. Try again');

    reader.readAsDataURL(file);
  }, [editor]);

  const handleOkClick = useCallback(() => {
    if (url) {
      editor.insertImage(url);
    }
    setModalOpened(false);
    setUploadError(null);
  }, [editor, url]);

  return (
    <div>
      <ImageIcon onClick={handleOpenClick} size={size} />
      <Modal
        className="image__fileUploadModal"
        visible={modalOpened}
        onCancel={handleCloseClick}
        zIndex={100001}
      >
        <ModalHeader>
          <h5>Insert image</h5>
        </ModalHeader>
        <ModalBody>
          {uploadError && <div className="image__modalError">{uploadError}</div>}
          <div className="image__modalBodySection">
            <FileUploadButton
              accept="image/png, image/jpeg, image/gif"
              onChange={handleFile}
              className="image__fileUploadButton"
            >
              <div>
                Upload image <FileUploadIcon size={size} />
              </div>
            </FileUploadButton>
          </div>
          <div className="image__modalBodySection">or</div>
          <Input
            className="image__modalBodySection image__modalUrlInput"
            placeholder="Enter URL"
            value={url}
            onChange={setUrl}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            kind="primary"
            onClick={handleOkClick}
          >
            Ok
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

PictureUploadButton.propTypes = {
  size: PropTypes.string,
  editor: PropTypes.shape({
    select: PropTypes.func,
    getLastPosition: PropTypes.func,
    insertImage: PropTypes.func,
  }),
};

export default memo(PictureUploadButton);
